import { ServerFetch } from '../main-model'

export default class FinanceDebitListModel extends ServerFetch {
    getFinanceDebitListBy = (data) => this.authFetch({
        url: 'finance-debit-list/getFinanceDebitListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generateFinanceDebitListBy = (data) => this.authFetch({
        url: 'finance-debit-list/generateFinanceDebitListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}